module.exports = __webpack_public_path__ + "img/j2.2e72a258.png";